<template>
  <div class="equipamentos-container">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="d-flex align-items-center">
        <button class="btn-back" @click="$router.push('/')">
          <i class="fas fa-arrow-left"></i>
        </button>
        <h1 class="page-title ml-3">Equipamentos</h1>
      </div>
      <span v-if="isSuperAdmin">
        <b-button class="btn-orange mb-3" @click="showModal()">
          <i class="fas fa-plus-circle mr-2"></i>Novo Equipamento
        </b-button>
      </span>
    </div>

    <div class="box">
      <div class="mb-4">
        <div class="flexline">
          <h2 class="filter-title">Filtrar</h2>
          <b-form-select v-model="sortOption" @change="applyFilter" :options="sortOptions" class="listbox" />
        </div>
      </div>

      <b-spinner v-if="loading" />
      <div v-else>
        <div class="table-responsive-wrapper">
          <b-table :items="sortedItems" :fields="fields" striped hover responsive class="modern-table">
            <template #cell(actions)="data" v-if="isSuperAdmin">
              <div class="action-buttons">
                <b-button class="btn-orange-action" @click="showModal(data.item)">
                  <i class="fas fa-edit"></i>
                  <span class="btn-text">Editar</span>
                </b-button>
                <b-button class="btn-orange-action" @click="showEmpresasModal(data.item.id, data.item.companyId)">
                  <i class="fas fa-building"></i>
                  <span class="btn-text">Empresa</span>
                </b-button>
                <b-button class="btn-orange-action" @click="showEmployeeModal(data.item.id)">
                  <i class="fas fa-user"></i>
                  <span class="btn-text">Pessoa</span>
                </b-button>
                <b-button class="btn-orange-action" @click="showHistoryModal(data.item.id, data.item.name)">
                  <i class="fas fa-history"></i>
                  <span class="btn-text">Histórico</span>
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </div>

      <p v-if="error">{{ error }}</p>
    </div>

    <b-modal
      id="equipamento-modal"
      ref="modal"
      :title="modalTitle"
      hide-footer
      @hidden="handleModalHidden"
    >
      <b-form @submit.stop.prevent="registerEquipamento">
        <b-row>
          <b-col md="6">
            <b-form-group label="Nome">
              <b-form-input
                v-model="equipamento.nome"
                type="text"
                required
                placeholder="Digite o nome do equipamento"
              />
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="isSuperAdmin">
            <b-form-group label="Identificador">
              <b-form-input
                v-model="equipamento.identificador"
                type="text"
                required
                placeholder="Digite o identificador"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" v-if="isSuperAdmin">
            <b-form-group label="Estado">
              <b-form-select
                v-model="equipamento.locationState"
                :options="localidades.locationState"
                required
                placeholder="Selecione o estado"
                @change="updateCitiesByState"
              >
                <b-form-select-option :value="null" disabled>Selecione o estado</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="isSuperAdmin">
            <b-form-group label="Cidade">
              <b-form-select
                v-model="equipamento.locationCity"
                :options="localidades.locationCity"
                :disabled="!equipamento.locationState"
                required
              >
                <b-form-select-option :value="null" disabled>Selecione a cidade</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Empresa">
              <b-form-select
                v-model="equipamento.empresa"
                :options="empresas"
                required
              >
                <template #first>
                  <b-form-select-option :value="null">Selecione uma empresa</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-button type="submit" class="btn-orange" :disabled="!isFormValid">{{ modalSubmitLabel }}</b-button>
        <b-button class="btn-cancel ml-2" @click="$refs.modal.hide()">Cancelar</b-button>
      </b-form>
    </b-modal>

    <EmpresasModal
      :empresas="empresas"
      :equipamento-id="selectedEquipamentoId"
      :empresa-equipamento="selectedEmpresaId"
      :equipamento="selectedEquipamentoObj"
    />

    <EquipmentEmployeeModal :equipmentId="modalEquipmentSelected"></EquipmentEmployeeModal>

    <EquipmentHistoryModal
      modal-id="equipment-history-modal"
      :equipment-id="historyEquipmentId"
      :equipment-name="historyEquipmentName"
    />
  </div>
</template>

<script>
import EquipmentHistoryModal from '@/components/modals/EquipmentHistoryModal.vue'
import { request } from '@/services'
import EmpresasModal from '@/components/modals/EmpresasModal.vue'
import EquipmentEmployeeModal from '../../modals/EquipmentEmployeeModal.vue'

export default {
  components: {
    EmpresasModal,
    EquipmentEmployeeModal,
    EquipmentHistoryModal
  },
  data () {
    return {
      items: [],
      allLocalidades: [],
      loading: true,
      error: null,
      selectedEquipamentoObj: {},
      equipamento: {
        nome: '',
        identificador: '',
        empresa: null,
        funcionario: null,
        locationState: null,
        locationCity: null,
        locationId: null
      },
      historyEquipmentId: null,
      historyEquipmentName: '',
      ultimoEquipamentoCriado: null,
      empresas: [],
      funcionarios: [],
      selectedEquipamentoId: null,
      selectedEmpresaId: null,
      sortOption: 'name',
      localidades: {
        locationState: [],
        locationCity: []
      },
      sortOptions: [
        { value: 'name', text: 'Ordenar por Nome' }
      ],
      modalEquipmentSelected: null,
      isEditing: false,
      editingEquipmentId: null
    }
  },
  computed: {
    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin
    },
    isManager () {
      return this.$store.getters.isManager
    },
    isFormValid () {
      return this.equipamento.nome &&
          this.equipamento.identificador &&
          this.equipamento.empresa &&
          this.equipamento.locationState &&
          this.equipamento.locationCity
    },
    modalTitle () {
      return this.isEditing ? 'Editar Equipamento' : 'Novo Equipamento'
    },
    modalSubmitLabel () {
      return this.isEditing ? 'Atualizar' : 'Salvar'
    },
    fields () {
      const baseFields = [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Nome' },
        { key: 'equipmentIdentification', label: 'Identificador' },
        { key: 'equipmentCity', label: 'Cidade' },
        { key: 'equipmentState', label: 'Estado' }
      ]
      // SuperAdmin sees company name and actions column
      if (this.isSuperAdmin) {
        baseFields.push(
          { key: 'companyName', label: 'Empresa' },
          { key: 'actions', label: 'Ações' }
        )
      }
      return baseFields
    },
    sortedItems () {
      return [...this.items].map(equip => ({
        ...equip,
        equipmentCity: equip.locationCity || 'Não disponível',
        equipmentState: equip.locationState || 'Não disponível',
        companyName: equip.companyName || 'Não disponível'
      })).sort((a, b) => {
        if (this.sortOption === 'name') {
          return a.name.localeCompare(b.name)
        }
        return 0
      })
    }
  },
  mounted () {
    if (!this.$store.getters.isSuperAdmin && !this.$store.getters.isReadOnly) {
      this.$router.push('/')
      return
    }

    this.fetchEquipamentos()
    this.fetchEmpresas()
    this.fetchLocalidades()
  },
  methods: {
    fetchEquipamentos () {
      request.get(
        'Equipments/with-names',
        response => {
          this.items = response.data
          this.loading = false
        },
        error => {
          this.error = 'Erro ao carregar equipamentos'
          this.loading = false
          console.error(error)
        }
      )
    },
    fetchEmpresas () {
      request.get(
        'Company',
        response => {
          if (Array.isArray(response.data)) {
            this.empresas = response.data.map(empresa => ({
              value: empresa.id,
              text: empresa.name
            }))
          } else {
            console.error('Estrutura de dados inesperada:', response.data)
          }
        },
        error => {
          console.error('Erro ao buscar empresas:', error)
        }
      )
    },
    fetchFuncionarios () {
      if (this.equipamento.empresa) {
        request.get(
          `Company/Funcionarios/${this.equipamento.companyId}`,
          response => {
            if (Array.isArray(response.data)) {
              this.funcionarios = response.data.map(func => ({
                value: func.id,
                text: func.name
              }))
            } else {
              console.error('Estrutura de funcionários inesperada:', response.data)
              this.funcionarios = []
            }
          },
          error => {
            console.error('Erro ao buscar funcionários:', error)
            this.funcionarios = []
          }
        )
      } else {
        this.funcionarios = []
      }
    },
    showModal (equipamento = null) {
      if (equipamento) {
        this.isEditing = true
        this.editingEquipmentId = equipamento.id
        this.equipamento = {
          nome: equipamento.name || '',
          identificador: equipamento.equipmentIdentification || '',
          empresa: equipamento.companyId || null,
          funcionario: null,
          locationState: equipamento.locationState || null,
          locationCity: equipamento.locationCity || null,
          locationId: equipamento.locationId || null
        }
        if (this.equipamento.locationState) {
          this.updateCitiesByState()
          this.equipamento.locationCity = equipamento.locationCity || null
        }
      } else {
        this.resetEquipmentForm()
        this.isEditing = false
        this.editingEquipmentId = null
      }
      this.$refs.modal.show()
    },
    showEmpresasModal (equipamentoId, empresaId) {
      if (equipamentoId) {
        this.selectedEquipamentoId = equipamentoId
        this.selectedEmpresaId = empresaId
        this.selectedEquipamentoObj = this.items.find(e => e.id === equipamentoId)
        this.$bvModal.show('empresas-modal')
      } else {
        console.error('ID do equipamento é nulo')
      }
    },
    showEmployeeModal (equipmentId) {
      this.modalEquipmentSelected = equipmentId
      this.$bvModal.show('equipment-employee-modal')
    },
    showHistoryModal (equipmentId, equipmentName) {
      this.historyEquipmentId = equipmentId
      this.historyEquipmentName = equipmentName
      this.$bvModal.show('equipment-history-modal')
    },
    registerEquipamento () {
      let selectedLocalidade = this.allLocalidades.find(loc =>
        loc.state === this.equipamento.locationState &&
        loc.city === this.equipamento.locationCity
      )

      if (!selectedLocalidade && this.equipamento.locationId) {
        selectedLocalidade = this.allLocalidades.find(loc => loc.id === this.equipamento.locationId)
      }

      if (!selectedLocalidade) {
        this.$bvToast.toast('Estado e cidade inválidos ou não encontrados.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        return
      }

      const payload = {
        name: this.equipamento.nome,
        equipmentIdentification: this.equipamento.identificador,
        companyId: this.equipamento.empresa,
        locationId: selectedLocalidade.id
      }

      if (this.isEditing && this.editingEquipmentId) {
        this.updateEquipamento(payload)
        return
      }

      request.post(
        'Equipments',
        payload,
        response => {
          this.ultimoEquipamentoCriado = response.data
          this.$refs.modal.hide()
          this.$bvToast.toast('Equipamento registrado com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
          this.fetchEquipamentos()
        },
        error => {
          console.error('Erro ao registrar equipamento:', error)
          this.$bvToast.toast('Erro interno do servidor.', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          })
        }
      )
    },
    updateEquipamento (payload) {
      request.put(
        `Equipments/${this.editingEquipmentId}`,
        {
          id: this.editingEquipmentId,
          ...payload
        },
        () => {
          this.$refs.modal.hide()
          this.$bvToast.toast('Equipamento atualizado com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
          this.fetchEquipamentos()
        },
        error => {
          console.error('Erro ao atualizar equipamento:', error)
          this.$bvToast.toast('Erro ao atualizar equipamento.', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          })
        }
      )
    },
    applyFilter () {
      // No-op: handled by computed 'sortedItems'
    },
    updateCitiesByState () {
      const selectedState = this.equipamento.locationState
      if (selectedState) {
        const cities = this.allLocalidades
          .filter(loc => loc.state === selectedState)
          .map(loc => loc.city)

        const uniqueCities = [...new Set(cities)]
          .map(city => ({ value: city, text: city }))

        this.localidades.locationCity = uniqueCities
      } else {
        this.localidades.locationCity = []
      }

      this.equipamento.locationCity = null
    },
    fetchLocalidades () {
      request.get('/Location', response => {
        if (response.data) {
          this.allLocalidades = response.data
          const states = [...new Set(response.data.map(loc => loc.state))]
            .map(state => ({ value: state, text: state }))

          this.localidades.locationState = states
          this.localidades.locationCity = []
        } else {
          this.error = 'Erro ao carregar localidades'
        }
      })
    },
    resetEquipmentForm () {
      this.equipamento = {
        nome: '',
        identificador: '',
        empresa: null,
        funcionario: null,
        locationState: null,
        locationCity: null,
        locationId: null
      }
      this.localidades.locationCity = []
    },
    handleModalHidden () {
      this.resetEquipmentForm()
      this.isEditing = false
      this.editingEquipmentId = null
    }
  }
}
</script>

<style scoped>
.equipamentos-container {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.btn-back {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border: none;
  color: white;
  width: 45px;
  height: 45px;
  min-width: 45px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);
  flex-shrink: 0;
}

.btn-back:hover {
  background: linear-gradient(135deg, #FF7A29 0%, #FF6810 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 140, 66, 0.4);
}

.btn-back i {
  font-size: 1.2rem;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0;
}

.box {
  padding: 30px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.box:hover {
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);
}

.filter-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #495057;
}

.flexline {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.listbox {
  max-width: 250px;
  border: 2px solid #FF8C42;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.listbox:focus {
  border-color: #FF7A29;
  box-shadow: 0 0 0 0.2rem rgba(255, 140, 66, 0.25);
}

/* Header responsive */
.d-flex.justify-content-between.align-items-center.mb-4 {
  flex-wrap: wrap;
  gap: 12px;
}

/* Tablet */
@media (max-width: 991px) {
  .page-title {
    font-size: 1.75rem;
  }

  .box {
    padding: 20px;
  }

  .listbox {
    max-width: 200px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .page-title {
    font-size: 1.5rem;
  }

  .box {
    padding: 16px;
    border-radius: 16px;
  }

  .flexline {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .listbox {
    max-width: 100%;
    width: 100%;
  }

  .filter-title {
    font-size: 1.1rem;
    margin-bottom: 8px;
  }

  /* Header responsive on mobile */
  .d-flex.justify-content-between.align-items-center.mb-4 {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 16px;
  }

  .d-flex.justify-content-between.align-items-center.mb-4 .btn-orange {
    width: 100%;
  }
}

/* Small mobile */
@media (max-width: 576px) {
  .btn-back {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 10px;
  }

  .btn-back i {
    font-size: 1rem;
  }

  .page-title {
    font-size: 1.25rem;
  }

  .box {
    padding: 12px;
    border-radius: 12px;
  }
}

/* Orange Button Styles */
.btn-orange {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border: none;
  color: white;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);
}

.btn-orange:hover {
  background: linear-gradient(135deg, #FF7A29 0%, #FF6810 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 140, 66, 0.4);
  color: white;
}

.btn-orange:active {
  transform: translateY(0);
}

.btn-orange:disabled {
  background: #cccccc;
  cursor: not-allowed;
  box-shadow: none;
}

/* Table Responsive Wrapper */
.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Action Buttons in Table */
.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.btn-orange-action {
  background-color: #FF8C42;
  border: none;
  color: white;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  white-space: nowrap;
}

.btn-orange-action:hover {
  background-color: #FF7A29;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 140, 66, 0.35);
  color: white;
}

.btn-orange-action:active {
  transform: translateY(0);
}

/* Cancel Button */
.btn-cancel {
  background-color: white;
  border: 2px solid #FF8C42;
  color: #FF8C42;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background-color: #FFF5EF;
  border-color: #FF7A29;
  color: #FF7A29;
}

/* Modern Table Styling */
.modern-table {
  border-radius: 12px;
  overflow: hidden;
}

.modern-table >>> thead {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  color: white;
}

.modern-table >>> thead th {
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  padding: 16px;
  border: none;
}

.modern-table >>> tbody tr {
  transition: all 0.2s ease;
}

.modern-table >>> tbody tr:hover {
  background-color: #FFF5EF;
  transform: scale(1.01);
}

.modern-table >>> tbody td {
  padding: 14px;
  vertical-align: middle;
  font-size: 0.95rem;
}

/* Table Responsive */
@media (max-width: 991px) {
  .modern-table >>> thead th {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .modern-table >>> tbody td {
    padding: 10px 8px;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .table-responsive-wrapper {
    margin: 0 -12px;
    padding: 0 12px;
  }

  .modern-table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    min-width: 700px;
  }

  .modern-table >>> thead th {
    padding: 10px 6px;
    font-size: 0.75rem;
    white-space: nowrap;
  }

  .modern-table >>> tbody td {
    padding: 8px 6px;
    font-size: 0.85rem;
  }

  .action-buttons {
    flex-direction: column;
    gap: 6px;
  }

  .btn-orange-action {
    width: 100%;
    padding: 6px 10px;
    font-size: 0.75rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
}

@media (max-width: 576px) {
  .modern-table {
    min-width: 600px;
  }

  .modern-table >>> thead th {
    padding: 8px 4px;
    font-size: 0.7rem;
  }

  .modern-table >>> tbody td {
    padding: 6px 4px;
    font-size: 0.8rem;
  }

  .btn-orange {
    padding: 8px 16px;
    font-size: 0.9rem;
    width: 100%;
  }

  .btn-orange-action {
    padding: 5px 8px;
    font-size: 0.7rem;
  }

  /* Hide ID column on very small screens */
  .modern-table >>> thead th:first-child,
  .modern-table >>> tbody td:first-child {
    display: none;
  }
}

/* Extra small mobile - hide button text, show only icons */
@media (max-width: 400px) {
  .btn-orange-action .btn-text {
    display: none;
  }

  .btn-orange-action {
    padding: 8px;
    min-width: 36px;
  }

  .btn-orange-action i {
    margin: 0;
  }
}

/* Modal form responsive */
@media (max-width: 768px) {
  #equipamento-modal .row {
    margin-left: 0;
    margin-right: 0;
  }

  #equipamento-modal .row > [class*="col-"] {
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 16px;
  }
}
</style>
